import { relations, sql } from "drizzle-orm";
import { bigserial, index, jsonb, pgTable, real, text, timestamp, uuid, boolean, unique, } from "drizzle-orm/pg-core";
import { agency } from "./main.js";
import { dossier, dossierDocument, dossierDocumentClassification, } from "./dossier.js";
export const dossierExtractionSuggestion = pgTable("dossier_extraction_suggestion", {
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    dossierId: uuid("dossier_id")
        .notNull()
        .references(() => dossier.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    documentId: uuid("document_id")
        .notNull()
        .references(() => dossierDocument.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    sourceClassificationId: uuid("source_classification_id")
        .notNull()
        .references(() => dossierDocumentClassification.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    classificationLabel: text("classification_label").notNull(),
    sectionType: text("section_type").notNull(),
    matchedCustomerId: text("matched_customer_id"),
    matchSource: text("match_source").notNull(),
    matchConfidence: real("match_confidence").notNull().default(0),
    status: text("status").notNull().default("nieuw"),
    dismissReason: text("dismiss_reason"),
    replacedBySuggestionId: uuid("replaced_by_suggestion_id"),
    reactivatedAfterDelete: boolean("reactivated_after_delete")
        .notNull()
        .default(false),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    updatedAt: timestamp("updated_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
}, (t) => [unique().on(t.documentId, t.classificationLabel)]);
export const dossierExtractionSuggestionRelations = relations(dossierExtractionSuggestion, ({ one }) => ({
    dossier: one(dossier, {
        fields: [dossierExtractionSuggestion.dossierId],
        references: [dossier.id],
    }),
    storedDocument: one(dossierDocument, {
        fields: [dossierExtractionSuggestion.documentId],
        references: [dossierDocument.id],
    }),
    sourceClassification: one(dossierDocumentClassification, {
        fields: [dossierExtractionSuggestion.sourceClassificationId],
        references: [dossierDocumentClassification.id],
    }),
    agency: one(agency, {
        fields: [dossierExtractionSuggestion.agencyId],
        references: [agency.id],
    }),
}));
export const dossierExtractionAudit = pgTable("dossier_extraction_audit", {
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    dossierId: uuid("dossier_id")
        .notNull()
        .references(() => dossier.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    documentId: uuid("document_id")
        .notNull()
        .references(() => dossierDocument.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    suggestionId: uuid("suggestion_id")
        .notNull()
        .references(() => dossierExtractionSuggestion.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    appliedBy: text("applied_by").notNull(),
    customerId: text("customer_id").notNull(),
    fieldGroup: text("field_group").notNull(),
    sourceLabel: text("source_label").notNull(),
    targetEntryId: text("target_entry_id"),
    createdNewEntry: boolean("created_new_entry").notNull().default(false),
    createdEntryId: text("created_entry_id"),
    fieldsApplied: jsonb("fields_applied")
        .$type()
        .notNull(),
    appliedAt: timestamp("applied_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    // Monotone, sequence-backed insertievolgorde. appliedAt gebruikt defaultNow()
    // (transactie-starttijd) en kan bij gelijke timestamp niet-deterministisch
    // ordenen; uuid v4 is geen insertievolgorde. auditOrder is de deterministische
    // tiebreaker voor "laatste audit"-lookups (desc(appliedAt) → desc(auditOrder)).
    auditOrder: bigserial("audit_order", { mode: "number" }).notNull(),
}, (t) => [
    // Composite index voor de "laatste audit per suggestie"-lookups (GET-handler +
    // apply-extraction idempotency-check + statusguard). Die filteren op suggestionId
    // en sorteren appliedAt DESC, auditOrder DESC. Zonder deze index moet Postgres de
    // groeiende audit-tabel scannen en sorteren per lookup.
    index("idx_audit_suggestion_latest").on(t.suggestionId, t.appliedAt.desc(), t.auditOrder.desc()),
]);
export const dossierExtractionAuditRelations = relations(dossierExtractionAudit, ({ one }) => ({
    dossier: one(dossier, {
        fields: [dossierExtractionAudit.dossierId],
        references: [dossier.id],
    }),
    storedDocument: one(dossierDocument, {
        fields: [dossierExtractionAudit.documentId],
        references: [dossierDocument.id],
    }),
    suggestion: one(dossierExtractionSuggestion, {
        fields: [dossierExtractionAudit.suggestionId],
        references: [dossierExtractionSuggestion.id],
    }),
    agency: one(agency, {
        fields: [dossierExtractionAudit.agencyId],
        references: [agency.id],
    }),
}));
